import type { IHistoryEntry } from '@platform/core/types';

/** Група події для фільтрів історії (прототип histFilters): коментар, зміна, зв'язок або інша подія (створення, видалення…). */
export type HistoryGroup = 'comment' | 'change' | 'link' | 'other';

const CHANGES = ['changed', 'status_changed', 'assigned', 'file_added', 'file_removed', 'acl_changed'];

/** Група події історії за її видом. Чиста функція. */
export function historyGroupOf(entry: Pick<IHistoryEntry, 'kind'>): HistoryGroup {
  if (entry.kind === 'comment') return 'comment';
  if (entry.kind === 'linked' || entry.kind === 'unlinked') return 'link';
  return CHANGES.includes(entry.kind) ? 'change' : 'other';
}

/** Чи значення зміни довге (довгий текст показується як «змінено», а не старе → нове). Чиста функція. */
export function isLongChange(entry: Pick<IHistoryEntry, 'from' | 'to'>): boolean {
  const text = `${entry.from ?? ''}${entry.to ?? ''}`;
  return text.length > 160 || /\n/.test(text);
}

/** Рядок CSV з екрануванням лапок (прототип fExportHistory). */
const cell = (v: unknown): string => `"${String(v ?? '').replace(/"/g, '""')}"`;

/**
 * CSV історії (прототип «Експорт історії»): BOM + заголовок «Коли,Хто,Тип,Подробиці»; подробиці — «поле: було → стало», текст
 * коментаря або «тип зв'язку · код назва». Чиста функція.
 */
export function historyCsv(entries: readonly IHistoryEntry[], head: string, kindLabel: (e: IHistoryEntry) => string, detail: (e: IHistoryEntry) => string): string {
  const lines = [head, ...entries.map((e) => [new Date(e.at).toISOString(), e.actor?.name ?? '', kindLabel(e), detail(e)].map(cell).join(','))];
  return `\uFEFF${lines.join('\n')}`;
}
